<div class="row p-2 ">
    <div class="col-sm-12 w-100">
        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


            <!--<img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="https://appointele.com/assets/logo2020w.png" />-->

                <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="./assets/logo2020w.png" />

            <div class="w-100 text-center">
                <h1 class="bg-black text-white pt-4" style="font-family:'DINPro';"  translate>WELCOME </h1>
            </div>

            <div class="border  bg-white "></div>
            <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';"> </h4>
            </div>





            <div class="jumbotron p-0" style="background: black;">
                <div class="container ">
                    <div class="row">
                        <div class="col-md-12 p-0 ">

                            <form [formGroup]="questionaireForm" class="text-center border border-light p-3">

                                <p class="h4 mb-4 text-white p-2" style="font-family:'DINPro'" translate>Please complete the following questionnaire</p>
                                <p class="h3 mb-4 text-danger p-2" style="font-family:'DINPro'" translate>* mandatory fields</p>

                                <div class="float-right w-100">
                                    <!--  <h3 class="float-left align-center py-3 text-danger"></h3> <div class="float-left py-4 text-danger">All fields are mandatory</div>-->
                                </div>
                                <br>
                                <!-- {{registerForm.value | json}}-->
                                <div class="form-group py-2">
                                    <label  translate class=" font-weight-bold text-white p-2 rounded w-100" style="text-align: start;font-family:'DINPro'">Full
                                        Name</label>
                                    <input type="text" formControlName="fullName" class="form-control"
                                        [class.is-invalid]="formErrors.fullName"
                                        (blur)="logValidationErrors(questionaireForm)" />

                                    <div [class.d-none]="!formErrors.fullName">
                                        <small class="text-danger" >{{formErrors.fullName}}</small></div>
                                </div>



                                <!--<div class="form-group py-2" >
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">Email</label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [class.is-invalid]="formErrors.email"
                                        (blur)="logValidationErrors(questionaireForm)" />

                                    <div [class.d-none]="!formErrors.email">
                                        <small class="text-danger">{{formErrors.email}}</small></div>

                                </div>-->






                                <div class="form-group py-2">
                                    <label  translate class="font-weight-bold text-white p-2 rounded w-100" style="text-align: start; font-family:'DINPro'">Phone
                                        Number</label>
                                    <input type="text" formControlName="phoneNumber" class="form-control"
                                        [class.is-invalid]="formErrors.phoneNumber"
                                        (blur)="logValidationErrors(questionaireForm)" />

                                    <div [class.d-none]="!formErrors.phoneNumber">
                                        <small class="text-danger">{{formErrors.phoneNumber}}</small></div>
                                </div>


                               <!-- <div class="form-group py-2">
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100">What age
                                        group do you belong to?</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="ageGroup" id="ageGroup" name="ageGroup" style="width: 100%; font-family:'DINPro'"
                                        tabindex="-1" aria-hidden="true" [class.is-invalid]="formErrors.ageGroup"
                                        (blur)="logValidationErrors(questionaireForm)">
                                        <option value='0'>SELECT</option>
                                        <option value="18-24">18 - 24</option>
                                        <option value="25-34">25 - 34</option>
                                        <option value="35-44">35 - 44</option>
                                        <option value="45-54">45 - 54</option>
                                        <option value="55-64">55 - 64</option>
                                        <option value="65-up">65 - up</option>
                                    </select>

                                    <div [class.d-none]="!formErrors.ageGroup">
                                        <small>{{formErrors.ageGroup}}</small></div>

                                </div>-->

                                <!--<div class="form-group py-2">
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">What best
                                        describes you?</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="describesYou" id="describesYou" name="describesYou"
                                        style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true"
                                       >
                                       <option value="Designer">Contractor</option>
                                        <option value="Homeowner">Homeowner</option>
                                        <option value="Fabricator">Fabricator</option>
                                        <option value="Designer">Designer</option>
                                    </select>

                                   

                                </div>


                                <div class="form-group py-2"
                                    *ngIf="questionaireForm.get('describesYou').value=='Fabricator'|| questionaireForm.get('describesYou').value=='Designer'">
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">What is the
                                        name of your company?</label>
                                    <input type="text" formControlName="companyName" class="form-control" />

                                </div>
                            -->



                            <div class="form-group py-2">
                                <label translate class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">Purpose of visit</label>
                                <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="lookingFor" id="lookingFor" name="lookingFor"
                                    style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true"
                                   >
                                    
                                    <option value="Slabs">Slabs</option>
                                    <option value="Tiles">Tiles</option>
                                    <option value="Slab/Tiles"> Slab/Tiles</option>
                                    <option value="Samples">Samples</option>
                                    <option value="Payment">Payments</option>

                                </select>

                              

                            </div>





                            <div class="form-group py-2 text-white">
                                <label class="font-weight-bold p-2 rounded w-100 " style="text-align: start;font-family:'DINPro'" translate>How did you hear about us?</label>
                                <!--<input type="text" formControlName="heardAboutUs" class="form-control" />-->
                                <select class="form-control select2tag select2-hidden-accessible"
                                formControlName="heardAboutUs" id="heardAboutUs" name="heardAboutUs"
                                style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true"
                               >
                                
                                <option value="Drive By">Drive By</option>
                                <option value="Designer">Designer</option>
                                <option value="Contractor"> Contractor</option>
                                <option value="Fabricator">Fabricator</option>
                                <option value="Family/Friends">Family/Friends</option>
                                <option value="Social Media">Social Media</option>
                                <option value="TV Ad">TV Ad</option>
                                <option value="Boxing Week Sale">Boxing Week Sale</option>
                            </select>

                                <!--<div class="d-flex flex-wrap text-white">
                                    <label class="m-2">
                                        <input class="mx-1" type="checkbox" [checked]="questionaireForm.controls['heardAboutUs'].value=='Drive By'"  (change)="questionaireForm.controls['heardAboutUs'].setValue('Drive By');heardAbout='Drive By';"/>Drive By
                                    </label>
                                    <label class="m-2">
                                    <input class="mx-1 text-white" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Designer'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Designer');heardAbout='Designer'"/>Designer
                                    </label>
                                    <label class="m-2">
                                        <input  class="mx-1 text-white"type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Contractor'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Contractor');heardAbout='Contractor'"/>Contractor
                                            </label>
                                            <label class="m-2">
                                         <input class="mx-1 text-white" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Fabricator'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Fabricator');heardAbout='Fabricator'"   />Fabricator
                                          </label>
                                          <label class="m-2">
                                         <input class="mx-1 text-white" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Family/Friends'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Family/Friends');heardAbout='Family/Friend'"/>Family/Friend
                                           </label>
                                         <label class="m-2">
                                        <input class="mx-1 text-white" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Social Media'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Social Media');heardAbout='Social Media'"/>Social Media
                                         </label>
                                         <label class="m-2">
                                            <input  class="mx-1 text-white  " type="checkbox"  [checked]="heardAbout=='Other'" (change)="questionaireForm.controls['heardAboutUs'].setValue('');heardAbout='Other'"/>Other
                                            
                                    </label>
                                    <input type="text" *ngIf="heardAbout=='Other'" formControlName="heardAboutUs" class="form-control" />
                                    </div>-->
                            </div>



                                <div class="form-group py-2 px-2 "  *ngIf="this.loggedInUsername=='5302device'">
                                    <label translate class="text-white font-weight-bold p-2 rounded w-100 " style="text-align: start; font-family:'DINPro'">Are you with a fabricator? If yes, please indicate the name of the company.</label>
                                    <input type="text" formControlName="workWithFabricator" class="form-control" />
                                </div>



                               <!--<div class="form-group py-2">
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100 " style="font-family:'DINPro'">Where have
                                        you heard about us?</label>
                                    <input type="text" formControlName="heardAboutUs" class="form-control" />
                                </div>


                                <div class="form-group py-2" hidden>
                                    <label class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">Reason for visit?</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="requestType" id="requestType" name="requestType"
                                        style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true"
                                       >
                                       <option value="Browsing">Browsing</option>
                                        <option value="Walk-In">Walk-In</option>
                                        <option value="Appointment">Appointment</option>
                                        <option value="Previous">Previous</option>
                                        <option value="Previous">Pick Up</option>
                                    </select>

                                   

                                </div>-->

<!--<div class="form-group py-2">
                                   <label class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro'">Please select location for appointment?</label>
-->
                              <!--      <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="branch" id="branch" name="branch"
                                        style="width: 100%; font-family:'DINPro';" tabindex="-1" aria-hidden="true"
                                        [class.is-invalid]="formErrors.branch"
                                        (blur)="logValidationErrors(questionaireForm)">
                                        <option value='0'>SELECT</option>
                                        <option value="Lawrence">Lawrence</option>
                                        <option value="Mississuaga">Mississuaga</option>
                                        <option value="Vaughan">Vaughan</option>
                                    </select>-->
                                   <!-- <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="branch" id="branch" name="branch"
                                    style="width: 100%;" tabindex="-1" aria-hidden="true" 
                               >
                                    <option value='0'>SELECT</option>
                                    <option *ngFor='let branch of branchs' value={{branch}}>{{branch}}</option>
                                
                                </select>

                                    <div [class.d-none]="!formErrors.branch">
                                        <small  class="text-danger">{{formErrors.branch}}</small></div>

                                </div>-->




                                <div class="form-group m-2 text-center d-flex flex-column ">
                                    <div *ngIf="loading">
                                        <h3 translate>Please wait...</h3>
                                    </div>
                                    <!--<div><img *ngIf="loading" class="pl-2 h-25 text-center"
                                            src="https://media.giphy.com/media/fxk77fLi2ZPQU6kHKx/giphy.gif" /></div>-->
                                            <div class="text-center"><button [disabled]=""
                                                [disabled]='!questionaireForm.valid || loading'
                                                 class="btn  text-dark "(click)="onSubmit()" 
                                                style="align-content: center;  background: white; font-family:'DINPro';"translate><i
                                                    class="fa fa-check" translate></i>Confirm</button>
                                        </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>


<!---------- Covid Modal ------------------------------------------------------------------------------------------------------------>
<!--<div class="modal fade " id="covidModal" tabindex="-1" role="dialog" style="background: black;"
    aria-labelledby="covidModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="covidModalLabel">
                    <strong></strong></h5>
        
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


   
                                              
                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://test.appointele.com/assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">COVID-19 SELF
                                    ASSESSMENT DECLARATION </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">I do not have any
                                    COVID-19 related symptoms and not have been in contact with anyone with COVID-19
                                    related symptoms. </h4>
                            </div>

                            



                            <div class="pt-5" style="display: block; margin-right: auto; margin-left: auto; ">
                                <h1 class="text-dark  mt-5 p-3 px-5 bg-white text-center"
                                    style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark "
                                    data-dismiss="modal"   (click)="onSubmit('Pass')">I AGREE</a></h1>
                            </div>
                            <div class="pb-5 " style="display: block; margin-right: auto; margin-left: auto; ">
                                <h1 class="text-dark  mb-5 p-3 bg-white text-center"
                                    style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark "
                                    data-dismiss="modal"  (click)="onSubmit('Fail')">I DO NOT AGREE</a></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>-->

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                 
                                               <!-- <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://appointele.com/assets/logo2020w.png" />-->

                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Your information has been forwarded.</h4>
                            </div>

                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Please confirm with reception that you have been signed in. </h4>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" routerLink='/welcome' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger">ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" routerLink='/assets' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>